import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useDetailStore = defineStore('detailItem', () => {

  const currentDetailItem = ref(null);

  const setCurrentDetailItem = cf => {
    currentDetailItem.value = cf
  }

  return {
    currentDetailItem,
    setCurrentDetailItem
  }

})